export default "__VITE_ASSET__CfAAoD3j__"